(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('ScheduledTask', ScheduledTask);

    ScheduledTask.$inject = ['$resource', 'DateUtils'];

    function ScheduledTask ($resource, DateUtils) {
        var resourceUrl =  'api/scheduled-tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.executionDate = DateUtils.convertDateTimeFromServer(data.executionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
